module.exports = __webpack_public_path__ + "media/Bruele.23029538.mp4";